export interface StratforthRuntimeConfig {
  keycloakUrl?: string;
  keycloakRealm?: string;
  keycloakClientId?: string;
  tenantId?: string;
  /**
   * MapLibre basemap style URL for the GIS map. Set at deploy time (helm runtime-config
   * ConfigMap) to point at a production basemap. When unset the map falls back to the build-time
   * REACT_APP_MAP_STYLE_URL and finally the MapLibre demo tiles. May contain a `{key}` placeholder
   * substituted from `mapApiKey`; never commit a provider key.
   */
  mapStyleUrl?: string;
  /**
   * Optional API key for a keyed basemap provider (e.g. MapTiler). Substituted into `mapStyleUrl`
   * wherever a `{key}` placeholder appears. Never commit a real key; supply it at deploy time.
   */
  mapApiKey?: string;
}

declare global {
  interface Window {
    __STRATFORTH_RUNTIME_CONFIG__?: StratforthRuntimeConfig;
  }
}

export const getRuntimeConfig = (): StratforthRuntimeConfig =>
  window.__STRATFORTH_RUNTIME_CONFIG__ || {};
